import { DownloadButton } from '@anytag/shared-atoms';
import { ListWithPagination } from '@anytag/shared-molecules';
import { useDownloadFile, useParamsSearch } from '@anytag/shared-hooks';
import { useAllInstagramMentionedPostsQuery } from '@anytag/graphql';
import { ProfilePostsCount, ProfilePostsFilter, AnalyticsInstagramMentionedPostsList } from '@anytag/shared-organisms';
import { getOffset, getUploadApiUrl, getValuableVariables, convertOrderToORDER } from '@anytag/shared-utils';
import { useInitialAnalyticsPosts } from '../hooks';
import { AnalyticsIgMentionedPostsSearchSchemaType } from './schema-types';

export const AnalyticsInstagramMentionedPosts = () => {
  const { downloading, handleDownloadFile } = useDownloadFile();
  const { brandAccountId, mainSocialAccountId } = useInitialAnalyticsPosts({
    socialMedia: 'instagram',
    analyticsProfileUrl: '/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/interaction',
    document: (name) => ({
      appHeader: name ? 'appHeader.MentionedPostsListWithAccountName' : 'appHeader.Mentioned Posts List',
      title: name ? 'documentTitle.MentionedPostsListWithAccountName' : 'documentTitle.Mentioned Posts List'
    })
  });
  const { page, limit, sort, filter, setFilter } = useParamsSearch<AnalyticsIgMentionedPostsSearchSchemaType>();
  const { data, previousData, loading } = useAllInstagramMentionedPostsQuery({
    skip: !brandAccountId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      accountId: Number(mainSocialAccountId),
      orderBy: { field: sort.field, order: convertOrderToORDER(sort.order) },
      ...filter
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allInstagramMentionedPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} hasPeriod />

      <ProfilePostsCount count={totalRecords}>
        <DownloadButton
          loading={downloading}
          onClick={() =>
            handleDownloadFile({
              filenamePrefix: 'mentionedPosts',
              url: getUploadApiUrl(`analytics/mentioned_post/${mainSocialAccountId}/csv`),
              params: getValuableVariables({ endDate: filter.endDate, startDate: filter.startDate })
            })
          }
        />
      </ProfilePostsCount>

      <AnalyticsInstagramMentionedPostsList
        loading={loading}
        mainSocialAccountId={mainSocialAccountId}
        data={result?.allInstagramMentionedPosts || []}
      />
    </ListWithPagination>
  );
};
